import React from "react";
import { AboutSection } from "../components/landing/AboutSection";
import { ContactSection } from "../components/landing/ContactSection";
import { FixedHeader } from "../components/landing/FixedHeader";
import { HeroSection } from "../components/landing/HeroSection";
import { WhatWeDoSection } from "../components/landing/WhatWeDoSection";
import {
  useActiveSection,
  useSectionScrollSnap,
} from "../components/landing/hooks";

/**
 * MatiMitra Carbon Solutions — Landing Page
 * Editorial, calm, credible. Restraint signals rigour.
 * Brand green: #1F7A40 (matched to logo).
 */
const Landing = () => {
  const heroRef = React.useRef(null);
  const aboutRef = React.useRef(null);
  const wwdRef = React.useRef(null);
  const contactRef = React.useRef(null);

  const sectionRefs = React.useMemo(
    () => [heroRef, aboutRef, wwdRef, contactRef],
    []
  );
  const observerEntries = React.useMemo(
    () => [
      { id: "hero", ref: heroRef },
      { id: "about", ref: aboutRef },
      { id: "work", ref: wwdRef },
      { id: "contact", ref: contactRef },
    ],
    []
  );

  useSectionScrollSnap(sectionRefs);
  const activeSection = useActiveSection(observerEntries);

  return (
    <main
      className="min-h-screen bg-[#FAF8F3] text-[#1A1A1A] font-sans antialiased overflow-x-hidden"
      data-testid="landing-page"
    >
      <FixedHeader activeSection={activeSection} />
      <HeroSection ref={heroRef} />
      <AboutSection ref={aboutRef} />
      <WhatWeDoSection ref={wwdRef} />
      <ContactSection ref={contactRef} />
    </main>
  );
};

export default Landing;
